module.exports = __webpack_public_path__ + "static/media/home.f7cd5a31.png";